export class FindingSensitiveDataLocation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectType",
            "baseName": "objectType",
            "type": "FindingObjectType",
            "format": ""
        },
        {
            "name": "dataClass",
            "baseName": "dataClass",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingSensitiveDataLocation.attributeTypeMap;
    }
    constructor() {
    }
}
